var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._l(_vm.list, function (item) {
    return _c('Content', {
      key: item.id,
      attrs: {
        "data": item
      }
    });
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };